/*
 * @Description: 活动门店列表（页面来源 特价推广marketingDetail, 聚合推广mergeSpread，商家自定义多店推广customDetail，商家自定义单店customSingularDetail，商家常规推广regularCustomDetail）
 * @Author: maowy
 * @Date: 2020-02-19 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-09-We 11:19:40
*/

import Vue from 'vue'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    getAllStoreList,
    getNearbySstores,
    getBusinessSstoreListMap,
    getSpecSstores
} from '@/models/storeList'
import storeListSearch from './storeListSearch/storeListSearch'
import InfiniteLoading from 'vue-infinite-loading'
import { Sticky } from 'vant'
Vue.use(Sticky)
export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.storeList,
    components: {
        InfiniteLoading,
        storeListSearch,
    },
    data () {
        return {
            longitude: '', // 当前位置经度
            latitude: '', // 当前位置纬度
            is_map: false, // true 地图  false 列表
            page: 1,
            limit: 20,
            storeIndex: 0, // 最近门店
            minDistanceStore: {}, // 最近门店
            isPosition: false, // 是否获取当前位置
            allStoreList: [], // 全部门店
            all_store_list_count: '', // 全部门店数量
            nearbySstoresList: [], // 门店列表-分页
            topic_id: '', // 专题id
            goods_id: '',
            spu_id: '',
            spec_id: '',
            activity_id: '', // 活动id，用于上报数据，跟过期无关系
            act_id: '', // 活动Id , 用于判断活动是否过期
            hasMore: true,
            hasData: true,
            ppt_goods_type: '',
            page_code: '', // 页面来源 特价推广marketingDetail, 聚合推广mergeSpread，商家自定义多店推广customDetail，商家自定义单店customSingularDetail，商家常规推广
            page_code_type: 1, // marketingDetail和mergeSpread为1，商家推广为2
            param: '',
            keyword: '', // 搜索
            topic_type: 0, // 商家推广类型：0常规 1自定义
            store_id: '', // 选中的商家id

            // 百度地图
            baidu_map: null, // 地图
            map_icon: {
                selfIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_self.png?x-oss-process=image/resize,w_22,h_30', new BMap.Size(22, 30)), // eslint-disable-line
                ohterIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_other.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)), // eslint-disable-line
                nearIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_near.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)) // eslint-disable-line
            },
            left_bottom_latitude: '', // 地图左下角-纬度
            left_bottom_longitude: '', // 地图左下角-经度
            right_top_latitude: '', // 右上角纬度
            right_top_longitude: '', // 右上角经度
            markerArr: [], // 地图标记数组
            flag: false, // 初始化地图状态
        }
    },
    watch: {
        is_map: {
            handler: function (newValue, oldValue) {
                console.log(newValue, oldValue, 'newValue')
                if (newValue) {
                    if (!this.flag) {
                        this.flag = true
                        this.$nextTick(() => {
                            this.initBaiduMap() // 当进入页面地图隐藏时，切换地图显示，解决获取不到地图西南和东北坐标问题
                        })
                    }
                }
            }
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
    },
    created () {
        /* isPosition是否获取当前位置 */
        const { topic_id, latitude, longitude, isPosition, goods_id, spu_id, spec_id, activity_id, act_id, ppt_goods_type, page_code, is_map, store_id, topic_type } = this.$route.query
        this.topic_id = topic_id
        this.latitude = latitude
        this.longitude = longitude
        this.isPosition = isPosition
        this.goods_id = goods_id
        this.spu_id = spu_id
        this.spec_id = spec_id
        this.activity_id = activity_id  // (不可能为空)活动id，用于上报数据，跟过期无关系
        this.act_id = act_id //  // (有可能为空)活动Id , 用于判断活动是否过期, 如果过期则活动id为空， 则那么价格显示不一样
        this.ppt_goods_type = ppt_goods_type
        this.page_code = page_code
        this.is_map = is_map || false
        this.store_id = store_id
        this.topic_type = topic_type || 0
        this.setTitle()
        if (this.page_code === 'customDetail' || this.page_code === 'customSingularDetail' || this.page_code === 'regularCustomDetail') { // 商家推广
            this.page_code_type = 2
            this.param = {
                topic_type: this.topic_type, // 推广类型：常规0 1自定义
                topic_id: this.topic_id, // 推广id topic_type=0 必填
                store_id: this.store_id, // 商家id
                spec_id: this.spec_id,
                latitude: this.latitude,
                longitude: this.longitude,
            }
        } else { // 特价推广 聚合推广
            this.page_code_type = 1
            this.param = {
                topic_id: this.topic_id,
                activity_id: this.activity_id,
                goods_id: this.goods_id,
                spec_id: this.spec_id,
                spu_id: this.spu_id,
                latitude: this.latitude,
                longitude: this.longitude,
                type: this.ppt_goods_type
            }
        }
    },
    activated () {
    },
    mounted () {
        /* 滚动到页面顶部 */
        document.body.scrollIntoView()
        // this.initBaiduMap()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getAllStoreList',
            'getNearbySstores',
            'getClosestSstores',
        ]),
        setTitle () {
            this.$emit('setHeader', {
                title: '活动周边门店',
                showHeader: true,
                showLeft: true
            })
            this.setAppClass({
                isAppend: false,
                className: 'bgGreyColor'
            })
        },
        /* 改变列表模式或者地图模式 */
        onChangeModel () {
            this.is_map = !this.is_map
            this.page = 1
            this.limit = 20
            if (!this.is_map) { // 地图
            } else {
                this.nearbySstoresList = []
                // this.getPageList()
            }
        },
        // 初始化地图
        initBaiduMap () {
            /* eslint-disable */
            // 百度地图API功能
            let _this = this
            // 初始化地图
            _this.baidu_map = new BMap.Map('allmap', { minZoom: 11 })
            let point = new BMap.Point(_this.longitude, _this.latitude)
            _this.baidu_map.centerAndZoom(point, 14)
            _this.baidu_map.disableDoubleClickZoom(true) // 禁止双击放大
            _this.baidu_map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放功能。仅对PC上有效
            // 当前定位maker
            let marker = new BMap.Marker(point, { icon: _this.map_icon.selfIcon })
            _this.baidu_map.addOverlay(marker)
            // 获取半径
            this.getBoundsCoord().then(() => {
                _this.getAllList() // 获取数据
            })
            // 滑动地图
            _this.baidu_map.addEventListener('dragend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            // 缩放地图
            _this.baidu_map.addEventListener('zoomend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            /* eslint-disable */
        },
        // 获取地图可视范围的四个角的坐标
        getBoundsCoord() {
            /* eslint-disable */
            let _this = this
            return new Promise((resolve, reject) => {
                let bounds = _this.baidu_map.getBounds() // 获取当前矩形
                let sw = bounds.getSouthWest(); // 西南角 左下
                let ne = bounds.getNorthEast(); // 东北角 右上
                // _this.left_bottom_longitude = bounds.Ul.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.Ul.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Dl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Dl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.El.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.El.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Vl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Vl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.Il.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.Il.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Yl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Yl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.lf.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.lf.lat // 左下-纬度
                // _this.right_top_longitude = bounds.of.lng // 右上-经度
                // _this.right_top_latitude = bounds.of.lat // 右上-纬度
                _this.left_bottom_longitude = sw.lng // 左下-经度
                _this.left_bottom_latitude = sw.lat // 左下-纬度
                _this.right_top_longitude = ne.lng // 右上-经度
                _this.right_top_latitude = ne.lat // 右上-纬度
                resolve()
            })
            /* eslint-disable */
        },
        // maker绘制
        getMarkerData() {
            let newMakerArr = [] // 增量标记
            if (!this.markerArr.length) { // 首次加载
                newMakerArr = this.allStoreList
            } else {
                this.allStoreList.forEach(itemArr => {
                    let obj = itemArr
                    let isExist = false
                    this.markerArr.forEach(oldMarkerArr => {
                        if (itemArr.id === oldMarkerArr.id) {
                            isExist = true
                        }
                    })
                    if (!isExist) {
                        newMakerArr.push(obj)
                    }
                })
            }
            this.markerArr = this.markerArr.concat(newMakerArr) // 把增量的数据push进来
            newMakerArr.forEach(item => {
                let point = new BMap.Point(item.longitude, item.latitude)
                let marker = new BMap.Marker(point, { icon: item.id === this.markerArr[0].id ? this.map_icon.nearIcon : this.map_icon.ohterIcon })
                this.baidu_map.addOverlay(marker)
                marker.id = item.id
                marker.addEventListener("click", (e) => {
                    this.jump(marker.id)
                });
            });
        },
        /* 重置地图位置 */
        onResetMap(longitude, latitude) {
            this.baidu_map.panTo(new BMap.Point(longitude, latitude))
        },
        // 获取全部门店
        getAllList() {
            let par = {
                ...this.param,
                // left_bottom_longitude: this.left_bottom_longitude,
                // left_bottom_latitude: this.left_bottom_latitude,
                // right_top_longitude: this.right_top_longitude,
                // right_top_latitude: this.right_top_latitude,
                left_bottom_latitude: this.right_top_latitude,
                left_bottom_longitude: this.right_top_longitude,
                right_top_latitude: this.left_bottom_latitude,
                right_top_longitude: this.left_bottom_longitude
            }
            if (this.page_code_type === 2) { // 商家推广
                getBusinessSstoreListMap(par).then(res => {
                    this.all_store_list_count = res.count
                    this.allStoreList = res.list
                    this.getMarkerData() // maker绘制
                    this.minDistanceStore = this.markerArr[this.storeIndex]
                })
            } else {
                getAllStoreList(par).then(res => { // 特价推广、聚合推广
                    this.all_store_list_count = res.count
                    this.allStoreList = res.list
                    this.getMarkerData() // maker绘制
                    this.minDistanceStore = this.markerArr[this.storeIndex]
                })
            }
        },
        // 获取门店-分页
        getPageList () {
            this.showLoading()
            if (this.page_code_type === 2) { // 商家推广
                Object.assign(this.param, {
                    page: this.page,
                    pagesize: this.limit,
                    sstore_name: this.keyword,
                    store_id: this.store_id,
                    keywords: this.keyword
                })
                getSpecSstores(this.param).then(res => {
                    this.all_store_list_count = res.total_count
                    this.disposePageData(res)
                    this.hideLoading()
                }).catch(() => {
                    this.hideLoading()
                })
            } else {
                Object.assign(this.param, {
                    page: this.page,
                    pagesize: this.limit,
                    sstore_name: this.keyword,
                })
                getNearbySstores(this.param).then(res => {
                    this.all_store_list_count = res.total_count
                    this.disposePageData(res)
                    this.hideLoading()
                }).catch(() => {
                    this.hideLoading()
                })
            }
        },
        // 处理分页数据
        disposePageData (res) {
            const { list } = res
            this.nearbySstoresList = this.nearbySstoresList.concat(list)
            this.hasData = !!this.nearbySstoresList.length
            if (list.length < this.limit) {
                this.hasMore = false
                this.$refs.infiniteLoading.stateChanger.complete()
            } else {
                this.page += 1
                this.$refs.infiniteLoading.stateChanger.loaded()
            }
            if (this.nearbySstoresList.length) {
                this.hasData = true
            } else {
                this.hasData = false
                this.hasMore = true
            }
        },
        /* 点击下一家门店 */
        nextStore() {
            let _this = this
            if (this.markerArr.length >= this.storeIndex + 2) {
                this.storeIndex++
                this.minDistanceStore = this.markerArr[this.storeIndex]
                this.onResetMap(this.markerArr[this.storeIndex].longitude, this.markerArr[this.storeIndex].latitude)
            } else {
                /* 返回第一家 */
                this.storeIndex = 0
                this.minDistanceStore = this.markerArr[this.storeIndex]
                this.onResetMap(this.markerArr[this.storeIndex].longitude, this.markerArr[this.storeIndex].latitude)
            }
        },
        /* 重置地图位置 */
        onSearch (keyword) {
            this.keyword = keyword
            this.page = 1
            this.nearbySstoresList = []
            this.getPageList()
        },
        /* 跳转 */
        jump (sstore_id) {
            if (this.spu_id) { // 跳转多店商品详情
                let param = {
                    goods_id: this.goods_id,
                    spu_id: this.spu_id,
                    spec_id: this.spec_id,
                    sstore_id: sstore_id,
                    store_id: this.page_code === 'regularCustomDetail' ? this.$route.query.store_id : '', // 商家常规推广需要传商家id
                    goods_type: 'agent',
                    topic_id: this.topic_id,
                    topic_type: this.topic_type,
                    page_code: this.page_code
                }
                this.$router.push({
                    name: 'moreSstoreGoodsDetail',
                    query: param
                })
            } else { // 跳转活动详情
                if (this.page_code === 'marketingDetail') { // 多店推广进来
                    this.$router.push({
                        name: 'specialActivity',
                        query: {
                            activity_id: this.activity_id,
                            topic_id: this.topic_id,
                            sstore_id: sstore_id,
                            latitude: this.latitude,
                            longitude: this.longitude,
                            page_code: this.page_code
                        }
                    })
                } else if (this.page_code === 'customDetail' || this.page_code === 'regularCustomDetail') {
                    this.$router.push({
                        name: 'customSingularGoodsList',
                        query: {
                            topic_id: this.topic_id,
                            topic_type: this.topic_type,
                            sstore_id: sstore_id,
                            store_id: this.$route.query.store_id,
                            latitude: this.latitude,
                            longitude: this.longitude,
                            page_code: this.page_code
                        }
                    })
                }
            }
        },
    },
    destroyed () {

    },
}
